import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,ChevronRight,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';

const FolderFilterCardThree =({activeCard,icon,title ,onClickPopup})=>{

    

 const Icon=   icon===0?<BookDown size={23}  color="#90CAF9" />:icon===1?<NotepadText size={23}  color="#90CAF9" 
        />:icon===2?<BookA size={23}  color="#90CAF9"  
        />:icon===3?<GalleryHorizontal size={23}   color="#90CAF9"  
        />:icon===4?<MonitorPlay size={23} color="#90CAF9" 
        />:icon===5?
       <Aperture size={23}   color="#90CAF9" />
       :icon===6?<Blocks size={23}  color="#90CAF9" />:icon===7?<CalendarCog size={23}  color="#90CAF9" />:"";
     
 const iconWhite=   icon===0?<BookDown size={23}  color="#fff" />:icon===1?<NotepadText size={23}  color="#fff" 
 />:icon===2?<BookA size={23}  color="#fff"  
 />:icon===3?<GalleryHorizontal size={23}   color="#fff"  
 />:icon===4?<MonitorPlay size={23} color="#fff" 
 />:icon===5?
<Aperture size={23}   color="#fff" />
:icon===6?<Blocks size={23}  color="#fff" />:icon===7?<CalendarCog size={23}  color="#fff" />:"";

     const dispatch = useDispatch();
     
      
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const cardBgColor =activeCard?"rgba(1,1,1,0.7)":"#333333 ";
      const styleCard={marginBottom:"20px",height:"60px",width:"80px",cursor:"pointer",border:"0px solid #fff",padding:"5px"}
      const cardBgIcon =activeCard?"rgba(144, 202, 249,0.1)":" #fff";
      const cardBorderColor =activeCard?"rgba(1,1,1,0.7)":"#f9f9f9";
      const styleCardIconIcon={background:cardBgIcon,color:cardBgColor,border:"2px solid "+cardBorderColor,fontSize:"12px",height:"40px",borderRadius:"15px",fontWeight:"bold",
        alignContent:"center",textAlign:"center",padding:"5px"}
      return (<>
        <div   onMouseEnter={
                ()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave}  onClick={()=>onClickPopup()} align="left" className="" 
 style={styleCard}> 
<div style={styleCardIconIcon}>{activeCard?title:title}</div> 

   <div  className="itemAppSettingsTopCard "></div>
  
   </div></>)
}
export default FolderFilterCardThree;

